/* src/app/views/dashboard/components/sidebar-nav/side-nav-footer/side-nav-footer.component.scss */
.bs-italic {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: italic;
}
.bs-regular {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}
.bs-medium {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
}
.bs-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: italic;
}
.bs-semi-bold {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.bs-semi-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: italic;
}
.bs-bold {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.f6px {
  font-size: 0.375rem;
}
.f8px {
  font-size: 0.5rem;
}
.f10px {
  font-size: 0.625rem;
}
.f11px {
  font-size: 0.6875rem;
}
.f12px {
  font-size: 0.75rem;
}
.f13px {
  font-size: 0.8125rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.side-nav-footer .sidebar-software-version {
  position: absolute;
  bottom: 0;
  margin-bottom: 0.25rem;
  font-size: 0.75rem;
  color: #c3c9d0;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
}
.side-nav-footer .sidebar-software-version .refresh-container {
  overflow: visible;
}
.side-nav-footer .sidebar-software-version .refresh-container .spin-refresh {
  width: 0.5rem;
  height: 0.5rem;
  -webkit-animation: spin-ccw 1.5s linear infinite;
  -moz-animation: spin-ccw 1.5s linear infinite;
  animation: spin-ccw 1.5s linear infinite;
}
.side-nav-footer .sidebar-software-version .web_socket_connection_status {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
}
/*# sourceMappingURL=side-nav-footer.component.css.map */
